import React from 'react';

import { FormProvider, useForm } from 'react-hook-form';

import Modal from '../../../../../utils/ModalComponet';

import FHReferenceForm, {
  FHReferenceFormInputProps,
  FHReferenceFormChanges,
} from './FHReferenceForm';

type Props = FHReferenceFormInputProps & {
  onClose: () => void;
  onApplyChanges: (data: FHReferenceFormChanges) => void;
};

const FHReferenceModal = ({
  onClose,
  onApplyChanges,
  itemId,
  customerPrototypeId,
}: Props) => {
  const methods = useForm();

  const handleCancelChanges = () => {
    onClose();
  };

  return (
    <Modal open closeModal={onClose}>
      <header>
        <h4>Fareharbor Reference</h4>
      </header>
      <main>
        <FormProvider {...methods}>
          <FHReferenceForm
            itemId={itemId}
            customerPrototypeId={customerPrototypeId}
            onApplyChanges={onApplyChanges}
          />
        </FormProvider>
      </main>
      <footer className='modal__footer'>
        <menu className='modal__actions'>
          <button
            type='button'
            className='btn btn-default'
            onClick={handleCancelChanges}
          >
            Cancel changes
          </button>
          <button
            type='submit'
            className='btn btn-primary'
            form='fhReferenceForm'
          >
            Apply changes
          </button>
        </menu>
      </footer>
    </Modal>
  );
};

export default FHReferenceModal;
